import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { User, Phone, Mail, Cake, Star, Coffee, CheckCircle, XCircle, Facebook, Linkedin, Youtube, Instagram, Music2, AlertCircle, Check, ActivityIcon, Calendar, Clock, CandyCane, AlarmClockCheck } from 'lucide-react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import './inputStyle.css';
import { Toast } from '../../components/Toast';
import { RegistrationCounter } from '../../components/RegistrationCounter';
import { BBBHighlights } from '../../components/events/BBBHighlights';
import { BBBSchedule } from '../../components/events/BBBSchedule';
import { BBBDressCode } from '../../components/events/BBBDressCode';
import ImagesDev from '../../api/images';
import EmailSender from './emailSender';


function BirthdayBibleBrunch() {
    const [form, setForm] = useState({
        first_name: "",
        surname: "",
        email_address: "",
        phone_number: "",
        volunteer: "",
        isEmailAvailable: false,
        isPhoneValid: false,
    });
    const [registrants, setRegistrants] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isRegistered, setIsRegistered] = useState(false);
    const [closedRegistration, setClosedRegistration] = useState(true);

    useEffect(() => {
        const fetchRegistrants = async () => {
            const endpoint = 'https://tsoministries.com/wp-json/wp/v2/bbb';
            let page = 1;
            let allRegistrants = [];

            try {
                while (true) {
                    const response = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=id,email_address`);

                    if (!response.ok) {
                        // If we've hit an invalid page number, assume we're done
                        if (response.status === 400 && page > 1) break;
                        throw new Error(`Error fetching page ${page}`);
                    }

                    const data = await response.json();

                    if (!Array.isArray(data) || data.length === 0) break;

                    allRegistrants = [...allRegistrants, ...data];
                    if (data.length < 100) break; // No more full pages
                    page++;
                }

                setRegistrants(allRegistrants);
            } catch (error) {
                console.error('Failed to fetch registrants:', error);
            } finally {
                setLoading(false);
            }
        };
        setRegistrants({length:727})
    }, []);

    const totalRegistered = registrants.length;
    const maxCapacity = (() => {
        if (totalRegistered <= 100) return 200;
        if (totalRegistered <= 200) return 250;
        if (totalRegistered <= 249) return 250;
        if (totalRegistered <= 299) return 300;
        if (totalRegistered <= 349) return 350;
        if (totalRegistered <= 399) return 400;
        if (totalRegistered <= 449) return 450;
        if (totalRegistered <= 499) return 500;
        if (totalRegistered <= 549) return 550;
        if (totalRegistered <= 599) return 600;
        if (totalRegistered <= 649) return 650;
        if (totalRegistered <= 699) return 700;
        if (totalRegistered <= 749) return 750;
        if (totalRegistered <= 799) return 800;
        const calculated = Math.ceil(totalRegistered * 1.4);
        return Math.ceil(calculated / 10) * 10;
    })();

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        if (form.isEmailAvailable === false) {
            Toast.error('Email is already in use. Please use another email.');
            setIsSubmitting(false);
            return;
        }

        if (form.isEmailAvailable === null) {
            Toast.error('Unable to verify email. Please check your connection and try again.');
            setIsSubmitting(false);
            return;
        }

        if (!form.isPhoneValid) {
            Toast.error('Your Phone number is not valid.');
            setIsSubmitting(false);
            return;
        }

        // Proceed to submit
        try {
            const response = await fetch("https://tsoministries.com/wp-json/custom-form/v1/bbb", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });

            const result = await response.json();
            if (response.ok) {
                sendEmail([{ id: 1600, email_address: form.email_address }]);
                setTimeout(() => {
                    Toast.success("Registration successful! We'll be in touch soon.");
                    setIsSubmitting(false);
                    setIsRegistered(true);
                }, 2000);
                // setForm({
                //     first_name: "",
                //     surname: "",
                //     email_address: "",
                //     phone_number: "",
                //     isEmailAvailable: null,
                //     isPhoneValid: false,
                // });
            } else {
                Toast.success("Something went wrong, Please post this issue in our issues page");
                setTimeout(() => {
                    setIsSubmitting(false);
                    throw new Error(result.message || 'Something went wrong');
                }, 600);
            }
        } catch (error) {
            Toast.error(error.message || 'Failed to submit form');
            setIsSubmitting(false);
        } finally {
            setTimeout(() => {
                setIsSubmitting(false);
            }, 2000);
        }
    };

    const sendEmail = async (registrants) => {
        for (const registrant of registrants) {
            try {
                const res = await fetch('https://tsoministries.com/wp-json/custom-api/v1/send-invite', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(registrant),
                });

                if (!res.ok) throw new Error(`Failed to send to ${registrant.email_address}`);
                // setSent(prev => [...prev, registrant]);
            } catch (err) {
                console.error(err);
                // setFailed(prev => [...prev, registrant]);
            }
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="relative min-h-screen text-white"
            style={{ backgroundColor: "#FFEEF1" }}
        >
            <div className="absolute h-[100%] inset-0">
                <img
                    src={ImagesDev.events.bbb.bg}
                    alt="Background"
                    className="fixed inset-0 w-full h-full object-cover opacity-20 blur-2xl"
                />
            </div>
            {/* Hero Section */}
            <div className="relative py-16 pt-24 md:pt-32 flex items-center justify-center overflow-hidden">

                {/* Blured BG */}
                <div className="absolute inset-0 bg-gradient-to-b from-gray-950/80 to-black/80" />
                <div className="absolute bg-black/40 inset-0">
                    <img
                        src="https://images.unsplash.com/photo-1464347744102-11db6282f854"
                        alt="Background"
                        className="absolute inset-0 w-full h-full blur-md object-cover opacity-20"
                    />
                </div>

                {/* Hero Forground */}
                <div className="container grid grid-cols-1 lg:grid-cols-6 mx-auto px-4 relative z-10">
                    {/* Left Content - Floating Testimony Cards */}
                    <div className="lg:col-span-3 order-2 lg:order-1 mt-6 md:mt-10 text-center md:text-left max-w-4xl mx-auto md:pr-10">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.5 }}
                        >
                            <h1 className="text-4xl md:text-7xl font-bold mb-6">
                                <span className="text-pink-300">Birthday · </span>
                                <span className="">Bible · </span>
                                <span className="text-pink-300">Brunch</span>
                            </h1>

                            <div className="mb-8">
                                <p className="text-lg md:text-xl md:italic text-gray-300 mb-2">
                                    It’s TSO’s 33rd birthday and what better way to enjoy the day than by sharing the Bible with family and friends!
                                </p>
                                <p className="text-lg md:text-xl md:italic text-gray-300 mb-4">
                                    We look forward to hosting you as we share word, food and laughter.
                                </p>
                                <p className="text-2xl font-semibold text-pink-300">#TITOSDOUBLE3</p>
                            </div>

                            <Countdown targetDate={new Date("2025-05-16T17:00:00+01:00")} />

                            {/* <p className="text-gray-400"> Attendance is free but registration is compulsory </p> */}
                        </motion.div>
                    </div>

                    {/* Right Content - Floating Testimony Cards */}
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.8, }}
                        className="lg:col-span-3 order-1 lg:order-2 relative h-[450px] md:h-[600px] block md:block flex justify-center items-center bg-black overflow-hidden rounded-3xl mb-8 md:mb-0"
                    >
                        <img
                            src={ImagesDev.events.bbb.bg}
                            alt="Healing Party"
                            className="relative w-full h-full object-cover"
                        />
                    </motion.div>
                </div>


                {/* Floating Elements */}
                {Array.from({ length: window.innerWidth > 768 ? 32 : 17 }).map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute"
                        initial={{
                            top: `${Math.random() * 100}%`,
                            left: `${Math.random() * 100}%`,
                            scale: 0
                        }}
                        animate={{
                            y: [-20, 20],
                            scale: [1, 1.2, 1],
                            rotate: 360
                        }}
                        transition={{
                            duration: Math.random() * 3 + 2,
                            repeat: Infinity,
                            repeatType: "reverse"
                        }}
                    >
                        {i % 3 === 0 ? (
                            <Cake className="w-4 h-4 text-pink-400/30" />
                        ) : i % 3 === 1 ? (
                            <Star className="w-4 h-4 text-pink-400/30" />
                        ) : (
                            <Coffee className="w-4 h-4 text-pink-400/30" />
                        )}
                    </motion.div>
                ))}
            </div>

            {/* Registration Section */}
            <div className="py-10 pt-16 bg-gradient-to-b from-gray-950/20 to-transparent bg-gray-900">
                <div className="container mx-auto px-4">
                    <div className="grid lg:grid-cols-2 gap-8 max-w-6xl mx-auto">
                        {/* Registration CLOSED */}
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                        >
                            <form onSubmit={handleSubmit} className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-pink-300/10 h-full flex flex-col justify-center items-center">
                                <h2 className="text-3xl font-bold mb-0 text-cente">Registration is closed!</h2>
                                <p className="text-xl mb-6 text-center">{form.first_name || "Great"}, Registration for the Birthday Bible Brunch is closed</p>
                                <div className='w-[150px] h-[150px] bg-white/10 rounded-full flex justify-center items-center'>
                                    <AlarmClockCheck className='w-[100px] h-[100px] text-pink-300' />
                                </div>
                            </form>
                        </motion.div>

                        {/* Registration counter */}
                        <motion.div
                            initial={{ opacity: 0, x: 20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                        >
                            <RegistrationCounter
                                totalRegistered={totalRegistered}
                                maxCapacity={closedRegistration ? totalRegistered : maxCapacity}
                                eventDate="May 16, 2025 | 5:00 PM"
                                eventLocation="The Venue was sent to your email if you have registred. Contact us for help"
                                theme_active="text-pink-300"
                                theme_bg_gradiemt="bg-gradient-to-r from-pink-500 to-pink-600"
                                theme_btn_bg="bg-pink-300/10"
                                theme_btn_text="text-pink-300"
                                className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 h-full"
                            />
                        </motion.div>
                    </div>
                </div>
            </div>

            {/* <EmailSender /> */}

            {/* Highlights Section */}
            <BBBHighlights />

            {/* Schedule Section */}
            {/* <BBBSchedule /> */}

            {/* Dress Code Section */}
            <BBBDressCode />
        </motion.div>
    );
}


export default BirthdayBibleBrunch





// ---------------------------
// Countdown component
// ---------------------------
function Countdown_old({ targetDate }) {
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [animatedValues, setAnimatedValues] = useState({ days: 100, hours: 100, minutes: 100, seconds: 0 });
    const countdownRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [initialAnimationDone, setInitialAnimationDone] = useState(false);

    // Calculate Time Left
    useEffect(() => {
        const calculateTimeLeft = () => {
            const difference = +targetDate - +new Date();
            if (difference > 0) {
                const newTimeLeft = {
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60),
                };
                setTimeLeft(newTimeLeft);
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        };

        calculateTimeLeft(); // initial call
        const timer = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    // Intersection Observer
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.5 }
        );

        if (countdownRef.current) {
            observer.observe(countdownRef.current);
        }

        return () => {
            if (countdownRef.current) {
                observer.unobserve(countdownRef.current);
            }
        };
    }, []);

    // Initial Animation for days, hours, minutes
    useEffect(() => {
        if (isVisible && !initialAnimationDone) {
            const animateKey = (key, targetValue) => {
                let current = 100;
                const step = (100 - targetValue) / 100; // speed

                const interval = setInterval(() => {
                    setAnimatedValues(prev => {
                        const newValue = Math.max(prev[key] - step, targetValue);
                        return { ...prev, [key]: Math.floor(newValue) };
                    });

                    current -= step;

                    if (current <= targetValue) {
                        clearInterval(interval);
                    }
                }, 30);
            };

            // Animate days, hours, minutes
            ["days", "hours", "minutes"].forEach(key => {
                animateKey(key, timeLeft[key]);
            });

            // Set seconds immediately
            setAnimatedValues(prev => ({ ...prev, seconds: timeLeft.seconds }));

            // After some delay, allow live sync
            setTimeout(() => {
                setInitialAnimationDone(true);
            }, 2000); // 2 seconds — enough time to finish animation
        }
    }, [isVisible, timeLeft, initialAnimationDone]);

    // Live update animatedValues after initial animation
    useEffect(() => {
        if (initialAnimationDone) {
            setAnimatedValues(timeLeft);
        }
    }, [timeLeft, initialAnimationDone]);

    return (
        <div className="container text-white">
            <div ref={countdownRef} className="max-w-4xl mx-auto">
                <h1 className="text-center md:text-left pb-2 text-white/30">Countdown</h1>
                <div className="grid grid-cols-4 gap-4 mb-0">
                    {[
                        { value: animatedValues.days, label: "Days" },
                        { value: animatedValues.hours, label: "Hours" },
                        { value: animatedValues.minutes, label: "Minutes" },
                        { value: animatedValues.seconds, label: "Seconds" },
                    ].map((item, index) => (
                        <div
                            key={index}
                            className="bg-white bg-opacity-10 backdrop-blur-lg rounded-lg py-6 text-center transform hover:scale-105 transition-transform duration-300"
                        >
                            <h1 className="text-4xl md:text-6xl font-bold mb-2">
                                {item.value}
                            </h1>
                            <p className="text-sm md:text-base uppercase tracking-wider" style={{ fontSize: 10 }}>
                                {item.label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function Countdown({ targetDate }) {
    const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    const [animatedValues, setAnimatedValues] = useState({ days: 100, hours: 100, minutes: 100, seconds: 100 });
    const countdownRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [animationComplete, setAnimationComplete] = useState(false);
    const [eventPassed, setEventPassed] = useState(false);

    useEffect(() => {
        const calculateTimeLeft = () => {
            const difference = +targetDate - +new Date();
            if (difference < 0) {
                setEventPassed(true);
                return {
                    days: 0,
                    hours: 0,
                    minutes: 0,
                    seconds: 0
                };
            }
            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        };

        const updateTimeLeft = () => {
            setTimeLeft(calculateTimeLeft());
        };

        updateTimeLeft(); // Initial calculation
        const timer = setInterval(updateTimeLeft, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !isVisible) {
                    setIsVisible(true);
                } else {
                    setIsVisible(false);
                }
            },
            { threshold: 0.2 }
        );

        if (countdownRef.current) {
            observer.observe(countdownRef.current);
        }

        return () => {
            if (countdownRef.current) {
                observer.unobserve(countdownRef.current);
            }
        };
    }, [isVisible]);

    useEffect(() => {
        if (isVisible && !animationComplete) {
            setAnimationComplete(true); // Ensure animation runs only once

            const animateCountdown = (key, value) => {
                let current = 100;
                const step = (100 - value) / 30; // Adjust speed here

                const countdownInterval = setInterval(() => {
                    setAnimatedValues((prev) => {
                        let newValue = Math.max(prev[key] - step, value);
                        return { ...prev, [key]: Math.floor(newValue) };
                    });

                    if (current <= value) {
                        clearInterval(countdownInterval);
                    }

                    current -= step;
                }, 50);
            };

            // Animate only for days, hours, and minutes (not seconds)
            Object.keys(timeLeft).forEach((key) => {
                if (key !== "seconds") {
                    animateCountdown(key, timeLeft[key]);
                }
            });

            // Set seconds to update dynamically
            setAnimatedValues((prev) => ({ ...prev, seconds: timeLeft.seconds }));
        }
    }, [isVisible, timeLeft, animationComplete]);

    // Update seconds in real-time
    useEffect(() => {
        if (animationComplete && isVisible) {
            setAnimatedValues((prev) => ({ ...prev, seconds: timeLeft.seconds }));
        }
    }, [isVisible, timeLeft.seconds, animationComplete]);

    const returnTimeName = (value, singular) => {
        return value === 1 ? singular : singular + "s";
    };

    return (
        <div className="container text-white">
            <div className="max-w-4xl mx-auto">
                <h1 ref={countdownRef} className="text-center md:text-left pb-2 text-white/30">Countdown</h1>
                <div className="grid grid-cols-4 gap-4 mb-0">
                    {[
                        { value: animatedValues.days, label: "Days" },
                        { value: animatedValues.hours, label: "Hours" },
                        { value: animatedValues.minutes, label: "Minutes" },
                        { value: animatedValues.seconds, label: "Seconds" },
                    ].map((item, index) => (
                        <div
                            key={index}
                            className="bg-white bg-opacity-10 backdrop-blur-lg rounded-lg py-6 text-center transform hover:scale-105 transition-transform duration-300"
                        >
                            <h1 className="text-4xl md:text-6xl font-bold mb-2">
                                {item.value}
                            </h1>
                            <p className="text-sm md:text-base uppercase tracking-wider" style={{ fontSize: 10 }}>
                                {item.label}
                            </p>
                        </div>
                    ))}
                </div>
                <h1 className="text-center md:text-left pt-2 text-white/30 text-[8px] opacity-50">only the value of "seconds" is set to animate for the best browser performance</h1>
            </div>
        </div>
    );
}



// ---------------------------
// BBBPhoneInput component
// ---------------------------
const BBBPhoneInput = ({ value, onChange, setForm }) => {
    const [phone, setPhone] = useState(value || "");
    const [isValid, setIsValid] = useState(true);

    useEffect(() => {
        if (!phone) {
            setIsValid(true);
            setForm((prev) => ({ ...prev, isPhoneValid: false }));
            return;
        }

        const valid = isValidPhoneNumber(phone);
        setIsValid(valid);

        setForm((prev) => ({ ...prev, isPhoneValid: valid }));
    }, [phone, setForm]);

    const handleChange = (value) => {
        setPhone(value);
        onChange({ target: { name: "phone_number", value } });
    };

    return (
        <div className="mb-6">
            <label className="block text-sm font-medium mb-2">Phone Number</label>
            <div className="relative">
                <PhoneInput
                    international
                    defaultCountry="NG" // Nigeria by default
                    value={phone}
                    onChange={handleChange}
                    className="w-full pl-5 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent transition-all duration-300"
                />
                {phone && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        {isValid ? (
                            <CheckCircle className="text-green-500 w-5 h-5" />
                        ) : (
                            <XCircle className="text-red-500 w-5 h-5" />
                        )}
                    </div>
                )}
            </div>

            {!isValid && phone?.length > 0 && (
                <p className="text-red-500 text-sm mt-1">
                    Invalid phone number, make sure your number is in the correct format +234 809 999 9999
                </p>
            )}
        </div>
    );
};

// ---------------------------
// BBBEmailInput component
// ---------------------------
const BBBEmailInput = ({ value, onChange, setForm }) => {
    const [email, setEmail] = useState(value || "");
    const [isValid, setIsValid] = useState(true);
    const [isAvailable, setIsAvailable] = useState(null);
    const [showEmailWarning, setShowEmailWarning] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!email) {
            setIsValid(true);
            setIsAvailable(null);
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isEmailValid = emailRegex.test(email);
        setIsValid(isEmailValid);
        setShowEmailWarning(true);

        if (!isEmailValid) {
            setIsAvailable(null);
            return;
        }

        const delay = setTimeout(async () => {
            setLoading(true);
            try {
                const available = await checkEmailAvailability(email);
                setIsAvailable(available);
            } catch (error) {
                console.error("Error checking email availability:", error);
                setIsAvailable(null); // Force null on any error
            } finally {
                setLoading(false);
            }
        }, 500);

        return () => clearTimeout(delay);
    }, [email]);

    // Always update parent form with current email availability
    useEffect(() => {
        if (!email) {
            setForm(prev => ({ ...prev, isEmailAvailable: null }));
            return;
        }

        if (isValid) {
            setForm(prev => ({ ...prev, isEmailAvailable: isAvailable }));
        } else {
            setForm(prev => ({ ...prev, isEmailAvailable: false }));
        }
    }, [email, isValid, isAvailable, setForm]);

    const handleChange = (e) => {
        setEmail(e.target.value);
        onChange({ target: { name: "email_address", value: e.target.value } });
    };

    return (
        <div className="mb-6">
            <label className="block text-sm font-medium mb-2">Email Address</label>
            <div className="relative">
                <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                    type="email"
                    name="email_address"
                    value={email}
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-3 bg-white/5 rounded-lg border border-white/10 focus:outline-none focus:ring-2 focus:ring-pink-400 focus:border-transparent transition-all duration-300"
                    required
                />
                {loading ? (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400">
                        Checking...
                    </div>
                ) : showEmailWarning && isValid && (
                    <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                        {isAvailable === true ? (
                            <CheckCircle className="text-green-500 w-5 h-5" />
                        ) : isAvailable === false ? (
                            <XCircle className="text-red-500 w-5 h-5" />
                        ) : email.length >= 1 && (
                            <AlertCircle className="text-yellow-500 w-5 h-5" />
                        )}
                    </div>
                )}
            </div>

            {showEmailWarning && !isValid && email.length > 0 && (
                <p className="text-red-500 text-sm mt-1">Invalid email format.</p>
            )}

            {showEmailWarning && isValid && isAvailable === false && (
                <p className="text-red-500 text-sm mt-1">
                    This email is already in use. You are registered already.
                </p>
            )}

            {email.length >= 1 && showEmailWarning && isValid && isAvailable === null && !loading && (
                <p className="text-yellow-500 text-sm mt-1">
                    Unable to verify email. Please check your internet connection.
                </p>
            )}
        </div>
    );
};

// -----------------------------------------
// checkEmailAvailability (utility function)
// -----------------------------------------
async function checkEmailAvailability(email) {
    const endpoint = 'https://tsoministries.com/wp-json/wp/v2/bbb';
    let page = 1;
    let emailExists = false;

    try {
        while (true) {
            const response = await fetch(`${endpoint}?per_page=100&page=${page}&_fields=id,email_address`);

            if (!response.ok) {
                // If 400 and page > 1, assume we've reached the end
                if (response.status === 400 && page > 1) {
                    break;
                }
                throw new Error(`Error fetching page ${page}`);
            }

            const data = await response.json();

            if (!Array.isArray(data) || data.length === 0) {
                break;
            }

            for (const item of data) {
                if (item.email_address && item.email_address.toLowerCase() === email.toLowerCase()) {
                    emailExists = true;
                    break;
                }
            }

            if (emailExists || data.length < 100) {
                break;
            }

            page++;
        }

        return !emailExists; // true = available
    } catch (error) {
        console.error('Failed to check email v2:', error);
        return null;
    }
}

